import SalesImpactAnalytics from './SalesImpactAnalytics';
import VeImpactAnalytics from './VeImpactAnalytics';
import {
  canAccessSeImpactAnalytics,
  canAccessVeImpactAnalytics,
} from './impactAnalyticsAccess';

export const IMPACT_CONSOLE_TABS = [
  {
    id: 'se-impact',
    label: 'SE Activities & Impact Analysis',
    Component: SalesImpactAnalytics,
    canAccessManager: canAccessSeImpactAnalytics,
  },
  {
    id: 've-impact',
    label: 'VE Activities & Impact Analysis',
    Component: VeImpactAnalytics,
    canAccessManager: canAccessVeImpactAnalytics,
  },
];

export const IMPACT_CONSOLE_TAB_IDS = IMPACT_CONSOLE_TABS.map((tab) => tab.id);

export const isImpactConsoleTab = (tabId) => IMPACT_CONSOLE_TAB_IDS.includes(tabId);
